type PropTypes = {
  className?: string
}

const BrandIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1695 1315"
      className={className}
    >
      <g filter="url(#a)" opacity=".3">
        <path fill="url(#b)" d="M1394.71 550.227c5.06-2.179 10.78 2.359 9.02 7.581C1301.15 861.268 857.289 1025 657.335 1025 454.462 1025 290 860.465 290 657.5S454.462 290 657.335 290c201.363 0 151.64 512.33 737.375 260.227Z" />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="428.6"
          x2="1021.97"
          y1="362.046"
          y2="830.466"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6F806" />
          <stop
            offset="1"
            stopColor="#C6F806"
            stopOpacity="0"
          />
        </linearGradient>
        <filter
          id="a"
          width="1694.05"
          height="1315"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur result="effect1_foregroundBlur_11_1053" stdDeviation="145" />
        </filter>
      </defs>
    </svg>
  )
}

export default BrandIcon
